import { render, staticRenderFns } from "./TemplateSealEditAreaComponent.vue?vue&type=template&id=c6ddd910&scoped=true&"
import script from "./TemplateSealEditAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateSealEditAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ddd910",
  null
  
)

export default component.exports